import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/common/context/useAuthContext';

const Root = () => {
	const { user } = useAuthContext();

	const getRootUrl = () => {
		if (user?.profile_type?.includes(1)) {
			return 'admin/home';
		} else if (user?.profile_type?.includes(2) || user?.profile_type?.includes(3)) {
			return 'cliente/home';
		}
		return 'cliente/home';
	};

	const url = getRootUrl();

	return <Navigate to={`/${url}`} />;
};

export default Root;
